export const createRepeatSlice = (set) => ({
  repetition: 'mirrorTwo',
  setRepetition: (value) => set({ repetition: value }),
})